import React, {useEffect, useState} from "react";
import IconButton from "@material-ui/core/IconButton";
import RemoveIcon from "@material-ui/icons/Remove";
import AddIcon from "@material-ui/icons/Add";
import {priceFormat} from "../../shared/util/util";
import Grid from "@material-ui/core/Grid";
import {useDispatch, useSelector} from "react-redux";
import {makeStyles} from "@material-ui/core/styles";
import {
    decrementCartQuantity,
    decrementSearchQuantity,
    incrementCartQuantity,
    incrementSearchQuantity,
    removeTire,
    setSearchQuantity
} from "../../core/redux/ActionCreator";
import {QUANTITY_MAX} from "../../shared/constants";

const styles = makeStyles({
    button: {
        height: '35px',
        width: '35px',
        padding: '11px 10px 10px 11px',
        margin: '0 0 0 4px' ,
        color: 'black',
        border: 'solid 1.5px',
        borderRadius: '50%',
        borderColor: 'black',
        '&$disabled': {
            borderColor: 'grey',
        }
    },
    mobile: {
        height: '20px',
        width: '20px',
        padding: '11px 10px 10px 11px',
        margin: '0 0 0 4px' ,
        color: 'black',
        border: 'solid 1.5px',
        borderRadius: '50%',
        borderColor: 'black',
        '&$disabled': {
            borderColor: 'grey',
        }
    },
    disabled: {},
    selector: {
        display: 'flex',
        alignItems: 'baseline',
        flexWrap: 'nowrap',
        justifyContent: 'flex-end',
    },
    centerAlignedSelector: {
        display: 'flex',
        alignItems: 'baseline',
        flexWrap: 'nowrap',
        justifyContent: 'center',
    },
    quantity: {
        width: '14px',
        height: '21px',
        margin: '7px 15px 7px 15px',
        fontFamily: 'Overpass',
        fontSize: '16px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: 'black',
    }
});

function QuantitySelector(props) {
    const dispatch = useDispatch();
    const classes = styles();

    const results = useSelector(state => state.searchResultReducer.results);
    const cart = useSelector(state => state.cartReducer.cart);
    const array = (props.page === 'search') ? results : cart;

    const [index, setIndex] = useState(array.findIndex(t => t.gmPartNum === props.gmPartNum));
    const [tire, setTire] = useState(array[index]);
    const [currentlyInCart, setCurrentlyInCart] = useState(0);
    const [max, setMax] = useState(QUANTITY_MAX);
    const [unitPrice] = useState(tire.price);
    const [displayBelow] = useState(props.displayBelow);
    const [justifyRight] = useState(props.justifyRight);
    const [totalPrice, setTotalPrice] = useState(priceFormat(0));
    const [disableDec, setDisableDec] = useState(false);
    const [disableInc, setDisableInc] = useState(false);
    const [showCartValue, setShowCartValue] = useState(false);

    let quantity = "Quantity";
    let grid = 12;
    let justify = 'flex-end'
    let direction = 'column-reverse'

    if (!displayBelow) {
        grid = 6;
        direction = 'row';
        quantity = "Qty";
    }

    if (justifyRight){
        justify = 'flex-end'
    }

    const increment = () => {
        const newQuantity = tire.quantity + 1;

        if (tire.quantity < max) {
            dispatch((props.page === 'search') ? incrementSearchQuantity({gmPartNum: tire.gmPartNum}) : incrementCartQuantity({gmPartNum: tire.gmPartNum}));
            setDisableInc(false);
        }

        if (newQuantity > 0) {
            setDisableDec(false);
        }
    };

    const decrement = () => {
        const newQuantity = tire.quantity - 1;

        if (tire.quantity > 0) {
            dispatch((props.page === 'search') ? decrementSearchQuantity({gmPartNum: tire.gmPartNum}) : decrementCartQuantity({gmPartNum: tire.gmPartNum}));
            setDisableDec(false);
        }

        if (newQuantity < max) {
            setDisableInc(false);
        }

        if ((newQuantity === 0) && (props.page === 'cart')) {
            console.log('remove tire');
            dispatch(removeTire({gmPartNum: props.gmPartNum}));
        }
    };

    useEffect(() => {
        if (props.page === 'search') {
            const cartIndex = cart.findIndex(t => t.gmPartNum === props.gmPartNum);

            if (cartIndex !== -1) {
                setCurrentlyInCart(cart[cartIndex].quantity);
                setShowCartValue(true);
                setMax(QUANTITY_MAX - cart[cartIndex].quantity);
            } else {
                setCurrentlyInCart(0);
                setShowCartValue(false);
                setMax(QUANTITY_MAX);
            }
        }

        setIndex(array.findIndex(t => t.gmPartNum === props.gmPartNum));
        setTire(array[index]);
    }, [props.gmPartNum, props.page, cart, array, index]);

    useEffect(() => {
        if (tire.quantity > max)
            dispatch(setSearchQuantity({quantity: max, gmPartNum: props.gmPartNum}));
    }, [props.gmPartNum, props.page, tire, max, dispatch]);

    useEffect(() => {
        if (tire.quantity === 0) {
            setDisableDec(true);
        }

        if (tire.quantity >= max) {
            setDisableInc(true);
        }

        function calculateTotal() {
            setTotalPrice(priceFormat(tire.quantity * unitPrice));
        }

        calculateTotal();
    }, [tire.quantity, max, unitPrice]);

    return (
        <div className="quantity-picker">
            {/*<div  className={'grid-container'} >*/}
            <Grid container spacing={1} direction={direction} alignItems={justify} justify-content={justify}>
                <Grid item xs={grid} justify-content='start'>
                    <div className={ displayBelow ? 'leftAlignment': ''}>
                        {displayBelow && <div className={'quantityText'}>{quantity}:</div>}
                        <br/>
                        <div className={displayBelow ? classes.centerAlignedSelector : classes.selector }>
                            {!displayBelow &&<div className={'qtyText'}>{quantity}:</div>}
                            <div className={'hide-on-desktop'}>
                            <IconButton classes={{root: classes.mobile, disabled: classes.disabled}} aria-label="decrement"
                                        disabled={disableDec} onClick={decrement}>
                                <RemoveIcon className='stat-icon-link'
                                            data-dtm= {props.brand + ':' + props.tireName}/>
                            </IconButton>
                            </div>
                            <div className={'hide-on-mobile'}>
                            <IconButton classes={{root: classes.button, disabled: classes.disabled}} aria-label="decrement"
                                        disabled={disableDec} onClick={decrement}>
                                <RemoveIcon className='stat-icon-link'
                                            data-dtm= {props.brand + ':' + props.tireName}/>
                            </IconButton>
                            </div>
                            <div className={'quantityNum'}>{tire.quantity}</div>
                            <div className={'hide-on-desktop'}>
                            <IconButton classes={{root: classes.mobile, disabled: classes.disabled}} aria-label="increment"
                                        disabled={disableInc} onClick={increment}>
                                <AddIcon className='stat-icon-link'
                                    data-dtm= {props.brand + ':' + props.tireName}/>
                            </IconButton>
                            </div>
                            <div className={'hide-on-mobile'}>
                            <IconButton classes={{root: classes.button, disabled: classes.disabled}} aria-label="increment"
                                        disabled={disableInc} onClick={increment}>
                                <AddIcon className='stat-icon-link'
                                    data-dtm= {props.brand + ':' + props.tireName}/>
                            </IconButton>
                            </div>
                        </div>
                    </div>
                </Grid>
                {props.priceFailed
                   ?<Grid item xs={grid}>
                        <div className={'totalText'}>Contact Dealer for Pricing</div>
                    </Grid>
                    :<Grid item xs={grid}>
                        <div className={'totalText'}>{totalPrice} Total</div>
                        <div className={'eachText'}>{priceFormat(unitPrice)} ea.</div>
                        {(props.page === 'search') && (showCartValue) &&
                        <div className={'currentlyInCart'}>{currentlyInCart} In Quote</div>
                        }
                        {displayBelow && <div>___________________</div>}
                </Grid>
                }
            </Grid>
        </div>
    )
}

export default QuantitySelector
